import { QueryClient } from "@tanstack/react-query";
import { isNetworkError, ZapirApiError } from "./errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error instanceof ZapirApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
      // "always" e nao "online": com "online" o TanStack pausa TODA query quando
      // `navigator.onLine` e falso, e esse flag fica preso em false no Chrome do
      // Android (economia de dados, VPN, otimizacao de bateria). Em 2026-09-19 um
      // celular ficou horas sem carregar nada enquanto `auth/refresh` e o
      // WebSocket — que usam fetch cru, fora do TanStack — respondiam 200 no log
      // do servidor. Tentar sempre: falha real vira erro de status 0, que a UI ja
      // trata como offline.
      networkMode: "always",
    },
    mutations: {
      retry: (failureCount, error) => isNetworkError(error) && failureCount < 2,
      networkMode: "always",
    },
  },
});

/** Chaves de query tipadas (evita strings soltas). */
export const qk = {
  me: () => ["me"] as const,
  conversations: (tenantId: string | null, filtro: string, extra?: string) =>
    ["conversations", tenantId, filtro, extra ?? ""] as const,
  conversation: (id: string) => ["conversation", id] as const,
  messages: (id: string) => ["messages", id] as const,
  labels: (tenantId: string | null) => ["labels", tenantId] as const,
  members: (tenantId: string | null) => ["members", tenantId] as const,
  notifications: (tenantId: string | null, tipo?: string) =>
    ["notifications", tenantId, tipo ?? ""] as const,
  channels: (tenantId: string | null) => ["channels", tenantId] as const,
  board: (tenantId: string | null, status: string) => ["board", tenantId, status] as const,
  search: (q: string, scope: string, conversationId?: string) =>
    ["search", q, scope, conversationId ?? ""] as const,
  push: (tenantId: string | null) => ["push", tenantId] as const,
};
